import { Button, type ButtonProps } from "../Button/Button";
import type { IconName } from "../Icon/Icon";
import { Tooltip } from "../Tooltip/Tooltip";

export interface IconButtonProps extends Omit<
  ButtonProps,
  "icon" | "iconEnd" | "children" | "pendingLabel" | "fullWidth"
> {
  icon: IconName;
  /** Accessible name, also shown as a tooltip unless `tooltip={false}`. */
  label: string;
  tooltip?: boolean;
}

/** A square icon-only button. The label is required: it becomes aria-label and the tooltip. */
export function IconButton({ icon, label, tooltip = true, variant = "ghost", ...rest }: IconButtonProps) {
  const button = <Button {...rest} variant={variant} icon={icon} aria-label={label} />;
  return tooltip ? <Tooltip content={label}>{button}</Tooltip> : button;
}
